<script lang="ts" setup>
import { defaultInitiative, Initiative } from '@/models/initiative.model';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { ContentStoreActions } from '@/stores/content.store';
import { ref } from 'vue';
import { useStore } from 'vuex';
import RichTextField from '../common/RichTextField.vue';
import { useI18n } from 'vue-i18n';

const store = useStore<ShiftCMSState>();
const { t } = useI18n();

const value = ref<Initiative>({ ...defaultInitiative });
const valid = ref<boolean>(true);
const created = ref<boolean>(false);

async function save() {
  if (!valid.value) {
    return;
  }

  const result = await store.dispatch(
    ContentStoreActions.CreateInitiative,
    value.value,
  );

  if (result.status) {
    store.dispatch(Actions.ShowNotification, {
      type: 'success',
      message: t('initiative.edit.created'),
    });
    store.dispatch(ContentStoreActions.GetInitiativesByContentEditor);
    created.value = true;
  } else {
    store.dispatch(Actions.ShowNotification, {
      type: 'warning',
      message: result.message,
    });
  }
}

function ok() {
  store.commit(Mutations.HideDrawer);
}

const rules = {
  required: (value: string) => !!value || t('initiative.edit.required'),
};
</script>
<template>
  <v-container>
    <h1>{{ $t('initiative.list.add') }}</h1>
    <div v-if="!created">
      <p class="mb-8 mt-4">{{ $t('initiative.edit.intro') }}</p>
      <v-form v-model="valid" @submit.prevent="save">
        <v-text-field
          v-model="value.title"
          :label="$t('initiative.edit.name')"
          :hint="$t('initiative.edit.nameHint')"
          :rules="[rules.required]"
          :valid="false"
        ></v-text-field>
        <RichTextField
          :label="$t('initiative.edit.description')"
          :hint="$t('initiative.edit.descriptionHint')"
          v-model="value.description"
          :height="300"
          :media="value.media"
          :rules="[rules.required]"
        />

        <v-container class="mt-4">
          <v-btn color="primary" type="submit">{{
            $t('initiative.edit.save')
          }}</v-btn>
        </v-container>
      </v-form>
    </div>
    <div v-if="created">
      <v-alert class="mt-4">{{ $t('initiative.edit.created_intro1') }}</v-alert>
      <v-alert class="mt-4">{{ $t('initiative.edit.created_intro2') }}</v-alert>
      <v-alert class="mt-4">{{ $t('initiative.edit.created_intro3') }}</v-alert>
      <v-alert class="mt-4">{{ $t('initiative.edit.created_intro4') }}</v-alert>
      <v-container class="mt-4">
        <v-btn color="primary" @click="ok">{{
          $t('initiative.edit.ok')
        }}</v-btn>
      </v-container>
    </div>
  </v-container>
</template>
<style scoped>
.slider-number {
  width: 40px;
  text-align: center;
}
</style>
